import React, { useContext } from 'react';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import SubHeader, {
	SubHeaderLeft,
	SubheaderSeparator,
} from '../../../layout/SubHeader/SubHeader';
import Page from '../../../layout/Page/Page';
import AuthContext from '../../../contexts/authContext';
import { demoPagesMenu } from '../../../menu';
import Announcement from '../../../components/management/announcement/Announcement';
import StaffPeriodSchedule from './dashboard-component/StaffPeriodSchedule';
import StaffActivity from './dashboard-component/StaffActivity';

const StaffDashboard = () => {
	const { userData } = useContext(AuthContext);

	return (
		<PageWrapper title={demoPagesMenu.sales.subMenu.dashboard.text}>
			<SubHeader>
				<SubHeaderLeft>
					<span className='fs-5'>Today Overview </span>
					<SubheaderSeparator />
					<strong className='fs-5'>Hi, <span className='text-primary'>{`${userData.fullname}`}</span> !</strong>
				</SubHeaderLeft>
			</SubHeader>
			<Page container='fluid'>
				<div className='row'>
					<div className='col-xl-12'>
						<Announcement />
					</div>
					<div className='col-8'>
						<StaffPeriodSchedule />
					</div>
					<div className='col-xl-4'>
						<StaffActivity />
					</div>
				</div>
			</Page>
		</PageWrapper>
	);
};

export default StaffDashboard;
